/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Timestamp_InvalidInputs */

const en_us2_workout_timestamp_invalid = /** @type {(inputs: Workout_Timestamp_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not read the time of this record. Check the phone's clock.`)
};

const pt_br2_workout_timestamp_invalid = /** @type {(inputs: Workout_Timestamp_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não conseguimos ler o horário deste registro. Confira o relógio do celular.`)
};

const es_419_workout_timestamp_invalid = /** @type {(inputs: Workout_Timestamp_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos leer la hora de este registro. Revisa el reloj del teléfono.`)
};

const pt_pt2_workout_timestamp_invalid = /** @type {(inputs: Workout_Timestamp_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não conseguimos ler a hora deste registo. Verifica o relógio do telemóvel.`)
};

const fr_fr2_workout_timestamp_invalid = /** @type {(inputs: Workout_Timestamp_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de lire l'heure de cet enregistrement. Vérifie l'horloge du téléphone.`)
};

const de_de2_workout_timestamp_invalid = /** @type {(inputs: Workout_Timestamp_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Uhrzeit dieses Eintrags konnte nicht gelesen werden. Prüf die Uhr deines Handys.`)
};

const it_it2_workout_timestamp_invalid = /** @type {(inputs: Workout_Timestamp_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non siamo riusciti a leggere l'orario di questa registrazione. Controlla l'orologio del telefono.`)
};

/**
* | output |
* | --- |
* | "We could not read the time of this record. Check the phone's clock." |
*
* @param {Workout_Timestamp_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_timestamp_invalid = /** @type {((inputs?: Workout_Timestamp_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Timestamp_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_timestamp_invalid(inputs)
	if (locale === "es-419") return es_419_workout_timestamp_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_timestamp_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_timestamp_invalid(inputs)
	if (locale === "de-DE") return de_de2_workout_timestamp_invalid(inputs)
	if (locale === "it-IT") return it_it2_workout_timestamp_invalid(inputs)
	return en_us2_workout_timestamp_invalid(inputs)
});
export { workout_timestamp_invalid as "workout.timestamp_invalid" }